var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tooltipId.length)?_c('span',{staticClass:"tooltip",on:{"click":_vm.showModal}},[_c('i',{class:[
      'fa-sharp',
      'fa-solid',
      'fa-circle-info',
      'tooltip__icon',
      _vm.isMultiParticipantDiscount ? 'tooltip__icon--gray' : ''
    ]}),_c('div',{attrs:{"id":_vm.tooltipId,"uk-modal":""}},[_c('div',{staticClass:"uk-modal-dialog uk-modal-body mobile-tooltip"},[_c('button',{staticClass:"uk-modal-close-default mobile-tooltip__close-btn",attrs:{"type":"button","uk-close":""}}),_c('h2',{staticClass:"uk-modal-title"},[_vm._v(_vm._s(_vm.currentDiscountName))]),_c('p',[_vm._v(_vm._s(_vm.currentDiscountDescription))])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }